import BackButton from '@/components/common/backButton';

const SkeletonLoader = () => {
    return (
        <div className="skeleton-container">
            <BackButton color="black" />
            <div className="gap"></div>
            <div className="skeleton-line short"></div>
            <div className="skeleton-line medium"></div>
            <div className="skeleton-box"></div>
            <div className="skeleton-line long"></div>
            <div className="skeleton-box"></div>
            <div className="skeleton-line medium"></div>
            <div className="skeleton-line short"></div>
            <style jsx>{`
                .skeleton-container {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    padding: 16px;
                    height: 100vh;
                    background: white;
                }
                .gap {
                    margin: 20px 0;
                }
                .skeleton-box,
                .skeleton-line {
                    background: linear-gradient(
                        90deg,
                        #e0e0e0 25%,
                        #f0f0f0 50%,
                        #e0e0e0 75%
                    );
                    background-size: 200% 100%;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                }
                .skeleton-box {
                    width: 100%;
                    height: 150px;
                }
                .skeleton-line.short {
                    width: 60%;
                    height: 24px;
                }
                .skeleton-line.medium {
                    width: 80%;
                    height: 24px;
                }
                .skeleton-line.long {
                    width: 100%;
                    height: 24px;
                }
                @keyframes shimmer {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default SkeletonLoader;
